import React, { useState, useEffect } from 'react';
import { Button, Form, Input, InputNumber, Radio, Select, TextArea } from 'components/shared/FormComponent';
import { useNavigate } from 'react-router-dom';
import { Empty, Table, TableProps, Popconfirm, Tooltip, message, Spin } from 'components/shared/AntComponent';
import 'assets/styles/commonStyle.scss';
import dayjs from 'dayjs';
import 'bootstrap/dist/css/bootstrap.min.css';
import { DeleteFilled, PlusSquareOutlined, MinusSquareOutlined } from 'components/shared/AntIcons';
import { getQuesTemplateDetail, getQuestionTemplate, saveQuestionTemplate } from 'services/store/actions/questionPaperAction';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { EditIcon } from 'assets/icons/CustomIcons';
import { getPublicCourse, getSubject } from 'services/store/actions/masterDataAction';
interface DataType {
    key: number;
    sectionCount: number;
    sectionName: string;
    exam_date: any;
    total_marks: string;
    exam_duration: string;
    description: any;
}

const ExamTemplate: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { templateInfo, loading11, success10, loading10, error10, loading12, templateDetailInfo } = useSelector((state: any) => state.questionpaper);
    const [form] = Form.useForm();
    const {  pubCourseInfo,loading30} = useSelector((state: any) => state.master);
    const [openModal, setOpenModal] = useState(false);
    const [sectionCount, setSectionCount]: any = useState(4);
    // const [fields, setFields] = useState<any[]>([]);
    // const [sections, setSections] = useState<any[]>([]);
    const data: any = !loading11 ? templateInfo?.data : [];
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [selectedCourses, setSelectedCourses] = useState([]);
    const [showSuccessmsg, setShowSuccessmsg] = useState(false);
    const successmsg = showSuccessmsg ? success10 : false;
    const [showErrormsg, setShowErrormsg] = useState(false);
    const errormsg = showErrormsg ? error10 : false;
    const [subjectOptions, setSubjectOptions]: any = useState({});
    const [selectedCoursesPerSection, setSelectedCoursesPerSection]: any = useState({});
    const [selectedSubjectsPerSection, setSelectedSubjectsPerSection]: any = useState({});
    const [sectionPercentages, setSectionPercentages] = useState<{ [key: number]: number }>({});
    const [forceUpdate, setForceUpdate] = useState(0);
    const [sectionMarks, setSectionMarks] = useState<{ [key: number]: number }>({});
    const [totalMarksValue, setTotalMarksValue] = useState<number>(0);
    const [quesID, setQuesID] = useState(0);
const [expandedRows, setExpandedRows] = useState<React.Key[]>([]);
    const defaultValue = !loading12 && templateDetailInfo?.data[0] || [];
    // Handle course change, update the selected courses state
    const handleCourseChange = (value: any, index: any) => {
        setSelectedCoursesPerSection((prevState: any) => ({
            ...prevState,
            [index]: value,
        }));
        const sectionSubjectOptions = pubCourseInfo?.data
            ?.filter((item: any) => item.masCourseID === value)
            ?.flatMap((item: any) =>
                item.subjects?.map((subject: any) => ({
                    label: subject?.subjectName,
                    value: subject?.masSubjectID
                }))
            );

        // Store options per section index
        setSubjectOptions((prevState: any) => ({
            ...prevState,
            [index]: sectionSubjectOptions || []
        }));
    };

    useEffect(() => {
        if (pubCourseInfo?.data) {
            const courseOptions = !loading30 && pubCourseInfo?.data?.map((item: any) => ({
                label: item?.courseName,
                value: item?.masCourseID,
                groupID: item?.groupID,
                groupName: item?.groupName
            }));
            setSelectedCourses(courseOptions);
        }
    }, [pubCourseInfo?.data]);

    const customLocale = {
        emptyText: <Empty className="p-2" description="No Subject Available" />,
    };

    const columns: TableProps<DataType>['columns'] = [
        {
            title: 'S.No',
            dataIndex: 'sno',
            key: 'sno',
            render: (id: any, record: any, index: number) => {
                if (pageIndex === 1) {
                    return index + 1;
                } else {
                    return (pageIndex - 1) * pageSize + (index + 1);
                }
            },
        },
        {
            title: 'Template Name',
            dataIndex: 'quesTemplateName',
            key: 'quesTemplateName',
        },
        {
            title: 'Total Marks',
            dataIndex: 'totalMarks',
            key: 'totalMarks',
        },
        {
            title: 'Created on',
            dataIndex: 'createdOn',
            key: 'createdOn',
            render: (_: any, record: any) => {
                const originalDate = new Date(record?.createdOn) || null;
                return data ? dayjs(originalDate).format('MM/DD/YYYY') : "--";
            },
        },
        {
            title: 'Status',
            dataIndex: 'isActive',
            key: 'isActive',
            render: (_: any, record: any) => {
                return (
                    <div>{record?.isActive ? <div className="bg-success px-2 py-1 text-white rounded text-center d-inline-block">Active</div> :
                        <div className="bg-danger px-2 py-1 text-white rounded d-inline-block text-center">Inactive</div>}</div>
                )
            }
        },
        {
            title: "Action",
            dataIndex: "action",
            key: "action",
            render: (_: any, record: any) => {
                return (
                    <div className="d-flex w-100">
                        <div className="pointer my-auto pb-3" onClick={() => editQuestion(record)}>
                            <EditIcon size={34} />
                        </div>
                    </div>
                );
            },
        }
    ];

    const editQuestion = (val: any) => {
        setOpenModal(true);
        setQuesID(val?.quesTemplateID);
        getTempDetail(val?.quesTemplateID);
        getCourseList();
    }

    function getTempDetail(value: number) {
        const id = Number(localStorage.getItem('tenantID')) + "/" + value;
        dispatch(getQuesTemplateDetail(id) as any);
    }

    function getTemplates(value: number) {
        const id = Number(localStorage.getItem('tenantID')) + "/" + value;
        dispatch(getQuestionTemplate(id) as any);
    }

    useEffect(() => {
        if (templateDetailInfo?.data && quesID !== 0 && openModal && pubCourseInfo?.data) {
            setTotalMarksValue(defaultValue?.totalMarks || 0);
            // Prepare subject options for each section based on their course
            const newSubjectOptions: any = {};
            const newSelectedCoursesPerSection: any = {};
            const newSectionPercentages: any = {};
            const newSectionMarks: any = {};

            defaultValue?.qpTemplateSections?.forEach((section: any, index: number) => {
                const courseID = Number(section?.courseID);

                // Store selected course for this section
                newSelectedCoursesPerSection[index] = courseID;

                // Get subject options for THIS SPECIFIC section's course
                const sectionSubjectOptions = pubCourseInfo?.data
                    ?.filter((item: any) => item.masCourseID == courseID)
                    ?.flatMap((item: any) =>
                        item.subjects?.map((subject: any) => ({
                            label: subject?.subjectName,
                            value: subject?.masSubjectID
                        }))
                    );

                // Store subject options for THIS section
                newSubjectOptions[index] = sectionSubjectOptions || [];

                // Calculate section percentage
                const sectionPercentage = section?.qpTemplateSubjects?.reduce(
                    (sum: number, subj: any) => sum + (Number(subj?.questionPercent) || 0),
                    0
                );
                newSectionPercentages[index] = sectionPercentage;

                // Calculate section marks
                const sectionMarks = (section?.totalQuestions || 0) * (section?.marksPerQuestion || 0);
                newSectionMarks[index] = sectionMarks;
            });

            // Update state FIRST before setting form values
            setSelectedCoursesPerSection(newSelectedCoursesPerSection);
            setSubjectOptions(newSubjectOptions); // Now an object with section-specific options
            setSectionPercentages(newSectionPercentages);
            setSectionMarks(newSectionMarks);
            form.setFieldsValue({
                templateName: defaultValue?.quesTemplateName || "",
                totalMarks: defaultValue?.totalMarks || null,
                description: defaultValue?.notes || "",
                duration: defaultValue?.duration ? Number(defaultValue?.duration) : null,
                sections: defaultValue?.qpTemplateSections?.map((section: any) => ({
                    "sectionID": section?.qpTempSectionId || 0,
                    "sectionName": section?.sectionName || "",
                    "questionNos": section?.totalQuestions || null,
                    "courses": Number(section?.courseID) || '',
                    "markPerQues": section?.marksPerQuestion || null,
                    "courseDifficultyLevel": section?.difficulty?.split(',') || "",
                    "randomQues": section?.isRandomized || false,
                    // "subjects": section?.qpTemplateSubjects?.map((subject: any, sectionIndex: number) => {
                    //     // Get the subject options for this specific section
                    //     const subjectOptions = newSubjectOptions[sectionIndex] || [];

                    //     // Find the matching subject by comparing label with subjectName
                    //     const matchingSubject = subjectOptions.find(
                    //         (opt: any) => opt.label === subject?.subjectName
                    //     );

                    //     return {
                    //         "subjectID": matchingSubject?.value || Number(subject?.subjectID) || 0,
                    //         "subjectName": matchingSubject?.value || '', // Bind the value (ID) so Select displays the label
                    //         "percentage": subject?.questionPercent || null,
                    //         "difficultyLevel": subject?.difficulty || ""
                    //     };
                    // })
                    "subjects": section?.qpTemplateSubjects?.map((subject: any) => ({
                        "qpTempSubjectId": subject?.qpTempSubjectId || 0,
                        "subjectID": subject?.subjectName || 0,
                        "subjectName": Number(subject?.subjectID) || '',
                        "percentage": subject?.questionPercent || null,
                        "difficultyLevel": subject?.difficulty || ""
                    }))
                }))
            });
        }
    }, [templateDetailInfo?.data, quesID, openModal, pubCourseInfo?.data])

    useEffect(() => {
        getTemplates(0);
    }, []);

    const goToPreviousScreen = () => {
        if (openModal) {
            handleCloseModal();
        } else {
            navigate('/question-paper');
        }
    }

    const handleOpenModal = () => {
        setOpenModal(true);
        getCourseList();
        setSectionCount(0);
        setSectionPercentages({});
        setSectionMarks({});
        form.resetFields();
        setQuesID(0);
        setTotalMarksValue(0);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
        setSectionPercentages({});
        setSectionMarks({});
    }

    const submitForm = async () => {
        try {
            const value = await form.validateFields();
// Validate section + subject together
const sections = value?.sections || [];

for (let i = 0; i < sections.length; i++) {
    const section = sections[i];

    if (!section.subjects || section.subjects.length === 0) {
        setExpandedRows([i]);
        message.error(`Please add at least one subject in Section ${i + 1}`);
        return;
    }

    const validSubjects = section.subjects.filter((sub: any) =>
        sub?.subjectName && sub?.percentage && sub?.difficultyLevel
    );

    if (validSubjects.length === 0) {
        setExpandedRows([i]);
        message.error(`Please fill subject details in Section ${i + 1}`);
        return;
    }
}
            // Validate total marks
            const totalMarks = value?.totalMarks || 0;
            const totalSectionMarks = calculateTotalSectionMarks();

            if (totalMarks !== totalSectionMarks) {
                message.error(`Total section marks (${totalSectionMarks}) must equal total marks (${totalMarks})`);
                return;
            }
            const sectionList = value?.sections?.map((item: any) => {
                // Calculate total marks for this section
                const sectionTotalMarks = Number(item?.questionNos) * Number(item?.markPerQues);

                return {
                    "QpTempSectionId": quesID !== 0 ? item.sectionID : 0,
                    "SectionName": item?.sectionName || "",
                    "TotalQuestions": item?.questionNos,
                    "TotalMarks": sectionTotalMarks,
                    "MarksPerQuestion": item.markPerQues || 1,
                    "Difficulty": item?.courseDifficultyLevel?.toString() || "",
                    "CourseID": item?.courses?.toString(),
                    "CourseName": pubCourseInfo?.data?.find((course: any) => course.masCourseID == item?.courses)?.courseName || "",
                    "IsRandomized": item?.randomQues || true,
                    "QuesTemplateID": quesID !== 0 ? defaultValue?.quesTemplateID : 0,
                    "QpTemplateSubjects": item.subjects?.map((itm: any) => {
                        // Calculate subject's total marks based on percentage
                        const subjectPercentage = Number(itm?.percentage) || 0;
                        const subjectTotalMarks = Math.round((sectionTotalMarks * subjectPercentage) / 100);

                        return {
                            "QpTempSubjectId": quesID !== 0 ? itm.qpTempSubjectId : 0,
                            "QpTempSectionId": quesID !== 0 ? item.sectionID : 0,
                            "QuesTemplateID": quesID !== 0 ? defaultValue?.quesTemplateID : 0,
                            "SubjectName": itm?.subjectID?.toString() || "",
                            "SubjectID": itm.subjectName?.toString() || "",
                            "QuestionPercent": itm?.percentage?.toString() || "",
                            "Difficulty": itm?.difficultyLevel || "",
                            "TotalMarks": subjectTotalMarks
                        };
                    })
                };
            });

            const inputJson = {
                "QuesTemplateID": quesID !== 0 ? defaultValue?.quesTemplateID : 0,
                "QuesTemplateName": value?.templateName || "",
                "QuesTemplateCode": "",
                "TotalMarks": value?.totalMarks || 0,
                "Duration": value?.duration?.toString() || "",
                "Notes": value?.description || "",
                "TenantId": Number(localStorage.getItem('tenantID')),
                "QpTemplateSections": sectionList || []
            }
            dispatch(saveQuestionTemplate(inputJson) as any);
            setShowSuccessmsg(true);
            setShowErrormsg(true);
        } catch (error: any) {
            console.log("Error", error);
        }
    }

    useEffect(() => {
        if (successmsg) {
            message.success('Template Saved successfully');
            getTemplates(0);
            handleCloseModal();
            setShowSuccessmsg(false);
        }
        if (errormsg) {
            if (error10?.message) {
                message.error(error10?.message);
            } else {
                message.error("Template couldn't be saved");
            }
            setShowErrormsg(false);
        }
    }, [successmsg, errormsg]);

    function getCourseList() {
        const id = Number(localStorage.getItem('tenantID')) + '/' + 0;
        dispatch(getPublicCourse(id) as any);
    }

    const diffLevelOptions = [
        { value: "easy", label: "Easy" },
        { value: "medium", label: "Medium" },
        { value: "hard", label: "Hard" }
    ];

    function getSubjectDetails() {
        const id = Number(localStorage.getItem('tenantID')) + "/" + 0;
        dispatch(getSubject(id) as any);
    }

    useEffect(() => {
        getSubjectDetails();
    }, []);


    // Validator for section marks - ensure it doesn't exceed remaining total marks
    const validateSectionMarks = (sectionIndex: number) => {
        return (_: any, value: any) => {
            const sections = form.getFieldValue('sections') || [];
            const currentSection = sections[sectionIndex];
            const totalMarks = totalMarksValue || 0;

            if (!totalMarks) {
                return Promise.resolve();
            }

            // Calculate what the marks would be with this new questionNos value
            const questionNos = Number(value) || 0;
            const markPerQues = Number(currentSection?.markPerQues) || 0;
            const thisSectionMarks = questionNos * markPerQues;

            // Calculate total marks from other sections
            const otherSectionsMarks = sections.reduce((total: number, _: any, idx: number) => {
                if (idx === sectionIndex) return total;
                const marks = sectionMarks[idx] ?? calculateSectionMarks(idx);
                return total + marks;
            }, 0);

            const totalSectionMarks = otherSectionsMarks + thisSectionMarks;

            if (totalSectionMarks > totalMarks) {
                return Promise.reject(`Total section marks (${totalSectionMarks}) cannot exceed total marks (${totalMarks})`);
            }

            return Promise.resolve();
        };
    };
    // Validator for subject percentage - ensure section total doesn't exceed 100%
    const validateSubjectPercentage = (sectionIndex: number, subjectIndex: number) => {
        return (_: any, value: any) => {
            if (value < 0 || value > 100) {
                return Promise.reject("Percentage must be between 0 and 100");
            }

            const sections = form.getFieldValue('sections') || [];
            const currentSection = sections[sectionIndex];

            if (!currentSection?.subjects) {
                return Promise.resolve();
            }

            // Calculate total percentage including this new value
            const totalPercentage = currentSection.subjects.reduce((sum: number, subject: any, idx: number) => {
                if (idx === subjectIndex) {
                    return sum + (Number(value) || 0);
                }
                return sum + (Number(subject?.percentage) || 0);
            }, 0);

            if (totalPercentage > 100) {
                return Promise.reject(`Total percentage (${totalPercentage}%) cannot exceed 100%`);
            }

            return Promise.resolve();
        };
    };

    // Calculate total percentage for a specific section
    const calculateSectionPercentage = (sectionIndex: number) => {
        const sections = form.getFieldValue('sections') || [];
        const section = sections[sectionIndex];

        if (!section?.subjects || section.subjects.length === 0) {
            return 0;
        }

        return section.subjects.reduce(
            (sum: number, subject: any) => sum + (Number(subject?.percentage) || 0),
            0
        );
    };

    // Calculate marks for a specific section (questionNos * markPerQues)
    const calculateSectionMarks = (sectionIndex: number) => {
        const sections = form.getFieldValue('sections') || [];
        const section = sections[sectionIndex];

        if (!section) return 0;

        const questionNos = Number(section?.questionNos) || 0;
        const markPerQues = Number(section?.markPerQues) || 0;

        return questionNos * markPerQues;
    };

    // Calculate total marks across all sections
    const calculateTotalSectionMarks = () => {
        const sections = form.getFieldValue('sections') || [];

        return sections.reduce((total: number, _: any, index: number) => {
            const sectionMark = sectionMarks[index] ?? calculateSectionMarks(index);
            return total + sectionMark;
        }, 0);
    };

    // Check if total marks limit is reached
    const isTotalMarksLimitReached = () => {
        const totalMarks = form.getFieldValue('totalMarks') || 0;
        const totalSectionMarks = calculateTotalSectionMarks();

        return totalMarks > 0 && totalSectionMarks >= totalMarks;
    };

    // Check if Add Subject button should be disabled for a specific section
    const isAddSubjectDisabled = (sectionIndex: number) => {
        const currentPercentage = sectionPercentages[sectionIndex] ?? calculateSectionPercentage(sectionIndex);
        return currentPercentage >= 100;
    };

    // Handle percentage change with immediate update
    const handlePercentage = (sectionIndex: number, value: any) => {
        // Recalculate the section percentage
        const newPercentage = calculateSectionPercentage(sectionIndex);

        setSectionPercentages(prev => ({
            ...prev,
            [sectionIndex]: newPercentage
        }));

        // Force re-render to update button states
        setForceUpdate(prev => prev + 1);
    };

    // Handle question number or mark per question change
    const handleSectionMarksChange = (sectionIndex: number) => {
        setTimeout(() => {
            const newMarks = calculateSectionMarks(sectionIndex);

            setSectionMarks(prev => ({
                ...prev,
                [sectionIndex]: newMarks
            }));

            // Trigger validation for questionNos field
            const sections = form.getFieldValue('sections') || [];
            if (sections[sectionIndex]) {
                form.validateFields([[`sections`, sectionIndex, 'questionNos']]);
            }

            // Force re-render to update button states
            setForceUpdate(prev => prev + 1);
        }, 0);
    };

    // Check if all sections have 100% subject allocation
    const canAddSection = () => {
        const sections = form.getFieldValue('sections') || [];
        const totalMarks = form.getFieldValue('totalMarks') || 0;

        // Check if total marks is filled
        if (!totalMarks || totalMarks === 0) {
            return false;
        }

        if (sections.length === 0) return true;

        // Check if total marks limit is reached
        if (isTotalMarksLimitReached()) {
            return false;
        }

        // Check if all sections have 100% subject percentage
        return sections.every((_: any, index: number) => {
            const percentage = sectionPercentages[index] ?? calculateSectionPercentage(index);
            return percentage === 100;
        });
    };

    // Get tooltip message for Add Section button
    const getAddSectionTooltip = () => {
        const totalMarks = form.getFieldValue('totalMarks') || 0;
        const totalSectionMarks = calculateTotalSectionMarks();

        // Check if totalMarks is not filled
        if (!totalMarks || totalMarks === 0) {
            return "Please fill in the Total Marks field before adding sections";
        }

        // Check if total marks limit is reached
        if (totalSectionMarks >= totalMarks) {
            return `Cannot add section. Total section marks (${totalSectionMarks}) has reached the limit of ${totalMarks}`;
        }

        // Check if any section doesn't have 100% subject allocation
        const sections = form.getFieldValue('sections') || [];
        const incompleteSections = sections.filter((_: any, index: number) => {
            const percentage = sectionPercentages[index] ?? calculateSectionPercentage(index);
            return percentage !== 100;
        });

        if (incompleteSections.length > 0) {
            return "All sections must have subjects totaling 100% before adding a new section";
        }

        return "";
    };

    const getAvailableSubjects = (sectionIndex: number, currentSubjectIndex: number) => {
        try {
            const sections = form.getFieldValue('sections') || [];
            const currentSection = sections[sectionIndex];

            // Get subject options for THIS specific section
            const currentSectionSubjectOptions = subjectOptions[sectionIndex];

            // If no subject options available yet, return empty array
            if (!currentSectionSubjectOptions || !Array.isArray(currentSectionSubjectOptions)) {
                console.log(`No subject options for section ${sectionIndex}`);
                return [];
            }

            // If no subjects in current section yet, return all available options for this section
            if (!currentSection?.subjects || !Array.isArray(currentSection.subjects)) {
                return currentSectionSubjectOptions;
            }

            // Get all selected subject IDs in current section except current row
            const selectedSubjectIds = currentSection.subjects
                .map((subj: any, idx: number) => {
                    if (idx === currentSubjectIndex) return null;
                    return subj?.subjectName;
                })
                .filter((id: any) => id != null && id !== '');

            // Filter out already selected subjects within this section
            return currentSectionSubjectOptions.filter(
                (option: any) => !selectedSubjectIds.includes(option.value)
            );
        } catch (error) {
            console.error('Error in getAvailableSubjects:', error, { sectionIndex, currentSubjectIndex });
            return [];
        }
    };

    const handleSubjectChange = (value: any, sectionIndex: number, subIndex: number, option: any) => {
        setSelectedSubjectsPerSection((prevState: any) => ({
            ...prevState,
            [sectionIndex]: [...(prevState[sectionIndex] || []), value],
        }));
        // Update the form to store both subjectID and subjectName
        const sections = form.getFieldValue('sections') || [];
        const currentSection = sections[sectionIndex];

        if (currentSection && currentSection.subjects && currentSection.subjects[subIndex]) {
            currentSection.subjects[subIndex].subjectID = option?.label;
            currentSection.subjects[subIndex].subjectName = value || '';
            form.setFieldValue('sections', sections);
        }
    };

    // Get available difficulty levels based on course difficulty selection
    const getAvailableDifficultyLevels = (sectionIndex: number) => {
        const sections = form.getFieldValue('sections') || [];
        const currentSection = sections[sectionIndex];

        if (!currentSection?.courseDifficultyLevel || currentSection.courseDifficultyLevel.length === 0) {
            return diffLevelOptions;
        }

        // Filter difficulty options based on selected course difficulty levels
        return diffLevelOptions.filter(option =>
            currentSection.courseDifficultyLevel.includes(option.value)
        );
    };

    const handleTotalMark = (e: any) => {
        setTotalMarksValue(e);
    }

    return (
        <div className='my-3 children-container'>
            <div className="row m-0 page-header">
                <h5 className="col-md-3 text-start my-auto text-secondary fw-bold">Question Paper Template</h5>
                <div className="ms-auto col-md-8 text-end my-auto pe-2">
                    <Button type="primary" className="col-auto ms-2 " onClick={handleOpenModal}>
                        Add
                    </Button>
                    <Button type="primary" className="col-auto ms-2 btn-back" onClick={goToPreviousScreen}>
                        Back
                    </Button>
                </div>
            </div>

            <div className="m-2 custom-table">
                {!openModal ?
                    <Table columns={columns} dataSource={data} loading={loading11} scroll={{ x: 'calc(230px + 50%)' }} className='table-responsive' rowKey="quesTemplateID" />
                    :
                    <Spin spinning={loading12}>
                        <div className='bg-white p-3 w-100'>
                            <Form form={form} layout="vertical" onFinish={submitForm} >
                                <div className='row mx-0'>
                                    <Form.Item label="Template Name" name="templateName" className='col'
                                        rules={[{
                                            required: true,
                                            message: 'This field is required',
                                        },
                                        {
                                            validator: (_, value) => {
                                                if (value < 1 || value > 5) {
                                                    return Promise.reject(new Error('No. of sections must be between 1 and 5'));
                                                }
                                                return Promise.resolve();
                                            },
                                        },]}>
                                        <Input />
                                    </Form.Item>
                                    <Form.Item label="Total Marks" name="totalMarks" className='col-md-2' rules={[{ required: true, message: 'This field is required' }]}>
                                        <InputNumber className='w-100' onChange={(e) => handleTotalMark(e)} />
                                    </Form.Item>
                                    <Form.Item label="Duration (mins)" name="duration" className='col-md-2'>
                                        <InputNumber className='w-100' />
                                    </Form.Item>
                                </div>
                                <div className='row mx-0'>
                                    <Form.Item name="description" label="Description">
                                        <TextArea rows={2} />
                                    </Form.Item>
                                </div>
                                <Form.List
                                    name="sections"
                                    initialValue={[
                                        {
                                            sectionID: 0,
                                            sectionName: '',
                                            courses: [],
                                            questionNos: '',
                                            markPerQues: '',
                                            courseDifficultyLevel: [],
                                            subjects: [{
                                                qpTempSubjectId: 0,
                                                subjectID: 0,
                                                subjectName: '',
                                                percentage: null,
                                                difficultyLevel: '',
                                            }],
                                        }
                                    ]}
                                >
                                    {(fields, { add: addSection, remove: removeSection }, index: any) => (
                                        <div className="px-2">
                                            <div className='row mx-0 mb-2 justify-content-between page-header'>
                                                <h6 className='col my-auto fw-bold ps-0 text-secondary'>Section Details</h6>
                                                <div className='text-end col-md-8'>
                                                    <Tooltip title={getAddSectionTooltip()}>
                                                        <Button
                                                            type="primary"
                                                            size="small"
                                                            className='ms-2'
                                                            onClick={() => addSection()}
                                                            disabled={!canAddSection()} // Disable if any section's total percentage is not 100
                                                        >
                                                            Add Section
                                                        </Button>
                                                    </Tooltip>
                                                </div>

                                            </div>
<Table
    rowKey="key"
    columns={[
                                                    {
                                                        title: 'Section Name',
                                                        dataIndex: 'sectionName',
                                                        width: '10%',
                                                        render: (_, record, index) => (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'sectionName']}
                                                                rules={[
                                                                    { required: true, message: 'This field is required' },
                                                                    ({ getFieldValue }) => ({
                                                                        validator(_, value) {
                                                                            const allSections = getFieldValue('sections') || [];
                                                                            const duplicates = allSections.filter(
                                                                                (item: any) =>
                                                                                    item.sectionName !== '' &&
                                                                                    item.sectionName?.toLowerCase() === value?.toLowerCase()
                                                                            );
                                                                            if (duplicates.length > 1) {
                                                                                return Promise.reject('Duplicate section name');
                                                                            }
                                                                            return Promise.resolve();
                                                                        },
                                                                    }),
                                                                ]}
                                                            >
                                                                <Input disabled={!totalMarksValue} />
                                                            </Form.Item>
                                                        ),
                                                    },
                                                    {
                                                        title: 'Courses',
                                                        dataIndex: 'courses',
                                                        width: '20%',
                                                        render: (_, record, index) => {
                                                            const selectedCoursesForOtherSections = Object.keys(selectedCoursesPerSection)
                                                                .filter(key => key !== String(index)) // Exclude current section
                                                                .map(key => selectedCoursesPerSection[key]);

                                                            const availableCourses: any = selectedCourses.filter((course: any) => !selectedCoursesForOtherSections?.includes(course?.value));
                                                            // const disabledCourses = selectedCourses.filter((course) => course !== undefined);
                                                            return (
                                                                <Form.Item
                                                                    className="mb-0"
                                                                    name={[index, 'courses']}
                                                                    rules={[{ required: true, message: 'This field is required' }]}
                                                                >
                                                                    <Select
                                                                        // mode="multiple"
                                                                        className="course-multiselect"
                                                                        options={availableCourses}
                                                                        autoClearSearchValue={false}
                                                                        onChange={(value) => handleCourseChange(value, index)}
                                                                        disabled={!totalMarksValue}
                                                                    />
                                                                </Form.Item>)
                                                        }

                                                    },
                                                    {
                                                        title: 'No. of Questions',
                                                        dataIndex: 'questionNos',
                                                        render: (_, record, index) => (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'questionNos']}
                                                                rules={[{
                                                                    validator: (_, value) =>
                                                                        value ? Promise.resolve() : Promise.reject("This field is required"),
                                                                }, { validator: validateSectionMarks(index) }]}
                                                            >
                                                                <InputNumber
                                                                    className="w-100"
                                                                    min={0}
                                                                    disabled={!totalMarksValue}
                                                                    onChange={() => handleSectionMarksChange(index)}
                                                                />
                                                            </Form.Item>
                                                        ),
                                                    },
                                                    {
                                                        title: 'Mark per Question',
                                                        dataIndex: 'markPerQues',
                                                        render: (_, record, index) => (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'markPerQues']}
                                                                rules={[{
                                                                    validator: (_, value) =>
                                                                        value ? Promise.resolve() : Promise.reject("This field is required"),
                                                                }, { validator: validateSectionMarks(index) }]}
                                                            >
                                                                <InputNumber className="w-100" onChange={() => handleSectionMarksChange(index)}
                                                                    disabled={!totalMarksValue} />
                                                            </Form.Item>
                                                        ),
                                                    },
                                                    {
                                                        title: 'Difficulty Level',
                                                        dataIndex: 'courseDifficultyLevel',
                                                        render: (_, record, index) => (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'courseDifficultyLevel']}
                                                                rules={[{ required: true, message: 'This field is required' }]}
                                                            >
                                                                <Select options={diffLevelOptions} mode="multiple"
                                                                    disabled={!totalMarksValue} />
                                                            </Form.Item>
                                                        ),
                                                    },
                                                    {
                                                        title: 'Random Question',
                                                        dataIndex: 'randomQues',
                                                        render: (_, record, index) => (
                                                            <Form.Item
                                                                className="mb-0"
                                                                name={[index, 'randomQues']}
                                                                rules={[{ required: true, message: 'This field is required' }]}
                                                            >
                                                                <Radio.Group
                                                                    options={[
                                                                        { value: true, label: 'Yes' },
                                                                        { value: false, label: 'No' }
                                                                    ]}
                                                                    disabled={!totalMarksValue}
                                                                />
                                                            </Form.Item>
                                                        ),
                                                    },

                                                ]}
                                                dataSource={fields}
                                                pagination={false}
                                                bordered
                                                size="small"
                                                className="section-table"
expandable={{
    expandedRowKeys: expandedRows,
    onExpandedRowsChange: (keys: React.Key[]) => setExpandedRows(keys),                                                    expandedRowRender: (record, index) => (
                                                        <Form.List name={[index, 'subjects']}
                                                            // rules={[
                                                            //     {
                                                            //         validator: (rule, value, callback) => validateTotalPercentage(rule, value, callback, index),
                                                            //     },
                                                            // ]}
                                                            initialValue={[
                                                                {
                                                                    subjectName: '',
                                                                    percentage: null,
                                                                    difficultyLevel: '',
                                                                }
                                                            ]}>
                                                            {(subjectFields, { add: addSubject, remove: removeSubject }) => (
                                                                <div className="py-2 px-3">
                                                                    <div className='row mx-0 mb-2 justify-content-between page-header'>
                                                                        <h6 className='col my-auto fw-bold ps-0 text-secondary text-decoration-underline'>Subject Details
                                                                            <span className="ms-3 text-sm">
                                                                                (Total: {sectionPercentages[index] ?? calculateSectionPercentage(index)}%)
                                                                            </span>
                                                                        </h6>
                                                                        <div className='text-end col-md-8'>
                                                                            <Tooltip
                                                                                title={isAddSubjectDisabled(index) ? "Cannot add more subjects. Total percentage is 100%" : ""}
                                                                            >
                                                                                <Button
                                                                                    type="primary"
                                                                                    // icon={<PlusOutlined />}
                                                                                    size="small"
                                                                                    className='ms-2'
                                                                                    onClick={() => addSubject()}
                                                                                    disabled={isAddSubjectDisabled(index)}
                                                                                >
                                                                                    Add Subject
                                                                                </Button>
                                                                            </Tooltip>
                                                                        </div>

                                                                    </div>
                                                                    <Table
                                                                        dataSource={subjectFields}
                                                                        rowKey="key"
                                                                        pagination={false}
                                                                        locale={customLocale}
                                                                        columns={[

                                                                            {
                                                                                title: 'Subject',
                                                                                dataIndex: 'subjectName',
                                                                                render: (_, __, subIndex) => {
                                                                                    // Step 1: Get all selected subjects across all sections except the current section
                                                                                    const selectedSubjectsForOtherSections = Object.keys(selectedSubjectsPerSection)
                                                                                        .filter(key => key !== String(index)) // Exclude current section
                                                                                        .flatMap(key => selectedSubjectsPerSection[key]);

                                                                                    // Step 2: Filter out the already selected subjects
                                                                                    // const availableSubjectOptions = subjectOptions.filter((subject:any) =>

                                                                                    // );
                                                                                    const availableSubjectOptions = getAvailableSubjects(index, subIndex);
                                                                                    return (
                                                                                        <Form.Item
                                                                                            className='mb-0'
                                                                                            name={[subIndex, 'subjectName']}
                                                                                            rules={[{ required: true, message: 'This field is required' }]}
                                                                                        >
                                                                                            <Select
                                                                                                options={availableSubjectOptions}
                                                                                                showSearch
                                                                                                onChange={(value, option) => handleSubjectChange(value, index, subIndex, option)}
                                                                                            />
                                                                                        </Form.Item>
                                                                                    );
                                                                                },
                                                                            },
                                                                            {
                                                                                title: 'Question Percentage',
                                                                                dataIndex: 'percentage',
                                                                                render: (_, __, subIndex) => (
                                                                                    <Form.Item
                                                                                        className='mb-0'
                                                                                        name={[subIndex, 'percentage']}
                                                                                        rules={[
                                                                                            { required: true, message: 'Percentage is required' },
                                                                                            // { validator: validatePercentage1 },
                                                                                            { validator: validateSubjectPercentage(index, subIndex) },
                                                                                        ]}
                                                                                    >
                                                                                        <InputNumber className="w-100" min={0} max={100}
                                                                                            // onChange={(value)=>handleSubjectPercentageChange(index, )}
                                                                                            onChange={(value) => handlePercentage(index, value)}
                                                                                        // onChange={(value) => handleSubjectPercentageChange(index, subIndex, value)}
                                                                                        />
                                                                                    </Form.Item>
                                                                                ),
                                                                            },
                                                                            {
                                                                                title: 'Difficulty Level',
                                                                                dataIndex: 'difficultyLevel',
                                                                                render: (_, __, subIndex) => (
                                                                                    <Form.Item
                                                                                        className='mb-0'
                                                                                        name={[subIndex, 'difficultyLevel']}
                                                                                        rules={[{ required: true, message: 'This field is required' }]}
                                                                                    >
                                                                                        <Select options={getAvailableDifficultyLevels(index)} />
                                                                                    </Form.Item>
                                                                                ),
                                                                            },
                                                                            {
                                                                                title: 'Actions',
                                                                                dataIndex: 'actions',
                                                                                align: 'center',
                                                                                render: (_, __, subIndex) => (
                                                                                    <div className="my-auto delete-icon d-flex text-center align-items-center justify-content-center">
                                                                                        {subIndex == 0 ? <Tooltip title="Atlease one subject should be added"><DeleteFilled className='text-gray del-icon' /></Tooltip> :
                                                                                            <Popconfirm title="Delete Subject" description="Are you sure to delete this subject?" onConfirm={() => removeSubject(subIndex)} okText="Yes" cancelText="No">
                                                                                                <DeleteFilled className="text-danger pointer del-icon" />
                                                                                            </Popconfirm>}
                                                                                    </div>
                                                                                ),
                                                                            },

                                                                        ]}
                                                                    />
                                                                </div>
                                                            )}
                                                        </Form.List>
                                                    ),
                                                    rowExpandable: () => true, // all rows are expandable
                                                    expandIcon: ({ expanded, onExpand, record }) => {
                                                        const rowIndex = fields.findIndex((f) => f.key === record.key); // Get correct index
                                                        return (
                                                            <div className="d-flex align-items-center">
                                                                {/* Default Expand Icon */}
                                                                {!totalMarksValue ?
                                                                    <Tooltip title="Total Mark field should be filled to proceed further">
                                                                        <span
                                                                            className="me-2"
                                                                            style={{ cursor: 'pointer' }}
                                                                        >
                                                                            <PlusSquareOutlined />
                                                                        </span>
                                                                    </Tooltip> :
                                                                    <span
                                                                        onClick={(e) => onExpand(record, e)}
                                                                        className="me-2"
                                                                        style={{ cursor: 'pointer' }}
                                                                    >
                                                                        {expanded ? <MinusSquareOutlined /> : <PlusSquareOutlined />}
                                                                    </span>}
                                                                {rowIndex == 0 ? <Tooltip title="Atleast one section should be added"><DeleteFilled className='text-gray del-icon' /></Tooltip> :
                                                                    < Popconfirm
                                                                        title="Delete Section"
                                                                        description="Are you sure you want to delete this section?"
                                                                        onConfirm={() => removeSection(rowIndex)}
                                                                        okText="Yes"
                                                                        cancelText="No"
                                                                    >
                                                                        <DeleteFilled className="text-danger pointer" />
                                                                    </Popconfirm>}
                                                            </div>
                                                        );
                                                    },
                                                }}
                                            />
                                        </div>)}
                                </Form.List>
                                <div className="row m-0 ps-3 page-footer-btns1 ques mt-3">
                                    <Button type="default" className="col-auto px-4 ms-auto bg-secondary text-white rounded-0 me-2" onClick={goToPreviousScreen}>
                                        Cancel
                                    </Button>
                                    <Button type="primary" htmlType="submit" className="px-4 col-auto mb-3 bg-success" loading={loading10}>
                                        Save
                                    </Button>
                                </div>

                            </Form></div>
                    </Spin>}
            </div>

        </div >
    )
}

export default ExamTemplate;